import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'elapsed'
})
export class ElapsedPipe implements PipeTransform {

  transform(value: number, args?: string): string {
    // Hours, minutes and seconds
    if(isNaN(value)){
      return args ? '-' + args : '-';
    }
    const hrs = Math.floor(value / 3600);
    const mins = Math.floor((value % 3600) / 60);
    const secs = value % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    let ret = '';
    if (args==='strava'){
      if (hrs>0){
        return hrs+'h '+mins+'m '+secs+'s';
      }
      return mins+'m '+secs+'s';
      }
    else if (args && args!=='strava'){
      if (hrs > 0) {
        ret += '' +  (hrs < 10 ? '0' : '') + hrs + ':' + (mins < 10 ? '0' : '');
      }
    } else {
      if (hrs > 0) {
        ret += '' + hrs + ':' + (mins < 10 ? '0' : '');
      }
    }
    ret += '' + mins + ':' + (secs < 10 ? '0' : '');
    ret += '' + secs;
    if(args) {
      return ret + ' / '+ args;
    }
    return ret;
  }

}
